(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bulk-purchase-cart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const qtyComponents = document.querySelectorAll('quantity-input[data-sync-id]');
  const groups = {};

  qtyComponents.forEach((comp) => {
    const id = comp.dataset.syncId;
    if (!groups[id]) groups[id] = [];
    groups[id].push(comp);
  });

  Object.values(groups).forEach((group) => {
    let initialValue = group[0].querySelector('input.quantity__input').value;

    group.forEach((comp) => {
      comp.querySelector('input.quantity__input').value = initialValue;
    });

    function syncAll(sourceComp) {
      const newVal = sourceComp.querySelector('input.quantity__input').value;

      group.forEach((comp) => {
        if (comp !== sourceComp) {
          const destInput = comp.querySelector('input.quantity__input');
          if (destInput.value !== newVal) {
            destInput.value = newVal;
            destInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    }

    group.forEach((comp) => {
      const input = comp.querySelector('input.quantity__input');
      const plus = comp.querySelector('button[name="plus"]');
      const minus = comp.querySelector('button[name="minus"]');

      input.addEventListener('input', () => syncAll(comp));
      input.addEventListener('change', () => syncAll(comp));

      plus.addEventListener('click', () => setTimeout(() => syncAll(comp), 30));
      minus.addEventListener('click', () => setTimeout(() => syncAll(comp), 30));
    });
  });
});

let bulkOpenState = false;

function initBulkToggle() {
  document.querySelectorAll('.bulk-toggle-btn').forEach(toggleBtn => {
    const cartItem = toggleBtn.closest('.cart-item');
    const collapsible = cartItem?.querySelector('.bulk-collapsible');

    if (!collapsible) return;

    if (toggleBtn.dataset.listenerAttached === 'true') return;
    toggleBtn.dataset.listenerAttached = 'true';

    toggleBtn.addEventListener('click', () => {
      collapsible.classList.toggle('open');
      toggleBtn.classList.toggle('rotated');
    });
  });
}

// Run on load
document.addEventListener("DOMContentLoaded", initBulkToggle);

// Detect Shopify cart updates
const observer = new MutationObserver(() => {
  initBulkToggle();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gtm"] && !Shopify.designMode) return;
  try {
    (function (window, document) {
    // -------------------------------------------------------
    // 1. INITIALISATION GTAG (Configuration de base)
    // -------------------------------------------------------
    const loc = window.location;
    const isDev = loc.hostname.includes('technipshop') || loc.hostname.includes('myshopify.com');
    const gkey = isDev ? 'G-XNE5GVJYTK' : 'G-FRDGYHBPHE';

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag; // Exposition globale immédiate

    // Injection du script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gkey}`;
    document.head.appendChild(script);

    // Config de base
    gtag('js', new Date());
    gtag('config', gkey, {
      anonymize_ip: true,
      send_page_view: true
    });

    // -------------------------------------------------------
    // 2. GESTION DE SESSION (Custom ID & Duration)
    // -------------------------------------------------------
    const SESSION_KEY = '_my_session_id';
    const START_KEY = '_my_session_start_ts';

    // Récupération ou création ID Session
    let sessionId = sessionStorage.getItem(SESSION_KEY);
    if (!sessionId) {
      sessionId = Date.now().toString(36) + Math.random().toString(36).substr(2);
      sessionStorage.setItem(SESSION_KEY, sessionId);
    }
    window.mySessionId = sessionId; // Gardé car utilisé ailleurs potentiellement

    // Récupération ou création Timestamp Début
    let startTs = sessionStorage.getItem(START_KEY);
    if (!startTs) {
      startTs = Date.now().toString();
      sessionStorage.setItem(START_KEY, startTs);
    }

    // Calcul durée
    const now = Date.now();
    const diffSec = Math.round((now - parseInt(startTs, 10)) / 1000);
    const sessionDurationSeconds = diffSec > 0 ? diffSec : 0;

    // Envoi event durée
    gtag('event', 'session_duration_update', {
      my_session_id: sessionId,
      session_duration_seconds: sessionDurationSeconds,
      debug_mode: true
    });

    // -------------------------------------------------------
    // 3. LOGIQUE PAR TYPE DE PAGE (Routing)
    // -------------------------------------------------------
    // On attend que le DOM soit prêt pour lire les H1
    const onDomReady = () => {
      const path = loc.pathname;

      // CAS : COLLECTIONS
      if (path.includes('/collections/')) {
        const titleEl = document.querySelector('h1');
        const collectionName = titleEl ? titleEl.textContent.trim() : 'unknown_collection';

        gtag('event', 'collection_view', {
          collection_name: collectionName,
          my_session_id: sessionId,
          debug_mode: true
        });
        return; // Stop ici si c'est une collection
      }

      // CAS : PRODUITS
      if (path.includes('/products/')) {
        const titleEl = document.querySelector('h1.product__title, h1');
        const productName = titleEl ? titleEl.textContent.trim() : 'unknown_product';
        
        // Accès sécurisé aux objets Shopify
        const shopifyMeta = window.ShopifyAnalytics?.meta?.product || window.meta?.product || {};
        
        gtag('event', 'view_item', {
          item_id: shopifyMeta.variants[0].sku || null,
          item_name: productName,
          price: shopifyMeta.variants[0].price || null,
          customer: window.ShopifyAnalytics?.meta?.page.customerId || null,
          my_session_id: sessionId,
          debug_mode: true
        });
      }
    };

    // Exécution de la logique DOM
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onDomReady);
    } else {
      onDomReady();
    }

  })(window, document);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pagination"] && !Shopify.designMode) return;
  try {
    document.getElementById('items-per-page-select').addEventListener('change', function (e) {
    const limit = e.currentTarget.value;
    const urlParams = new URLSearchParams(window.location.search);
    const searchedValue = urlParams.get('q');
    let url = window.location.href;
    if (url.includes('?')) url = url.split('?')[0];

    let redirectTo = url + '?page=1&limit=' + limit;
    if (url.includes('search')) redirectTo += '&q=' + searchedValue;

    window.location.href = redirectTo;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-facets"] && !Shopify.designMode) return;
  try {
    var activeFacetsContainer = document.getElementsByClassName('active-facets-container')[0];
  var removeFilter = document.getElementsByClassName('active-facets__remove-filters')[0];

  removeFilterStyleChecker();

  setInterval(removeFilterStyleChecker, 100);

  function removeFilterStyleChecker() {
    if (activeFacetsContainer.children.length == 0) {
      removeFilter.style.display = 'none';
      activeFacetsContainer.style.marginTop = '0px';
    } else {
      removeFilter.style.display = 'flex';
      removeFilter.style.marginTop = '6px';
      activeFacetsContainer.style.marginTop = '20px';
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["welcome-dicsount-popup"] && !Shopify.designMode) return;
  try {
    (function(){
      var KEY = 'wp_welcome_seen';
      try { if (localStorage.getItem(KEY)) return; } catch(e){}
      var el = document.getElementById('wp-popup');
      if (!el) return;
      setTimeout(function(){ el.classList.add('is-visible'); }, 3000);
      document.getElementById('wp-popup-close').addEventListener('click', function(){
        el.classList.remove('is-visible');
        try { localStorage.setItem(KEY, '1'); } catch(e){}
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
